import { Component, OnInit, AfterViewInit } from '@angular/core';
import { PreloaderService } from '@core';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
// import{FccpLogin} from './routes/sessions/FCCP/login/fccp-login'
import {AuthService}from './auth-guard/auth.service';
import { MtxDialog } from '@ng-matero/extensions/dialog';
// import {MatDialog} from '@angular/material/dialog';
@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(private preloader: PreloaderService,private bnIdle: BnNgIdleService,private router: Router,private authservice:AuthService,private dialog: MtxDialog) {

  }

  ngOnInit() {
    this.bnIdle.startWatching(900).subscribe((isTimedOut: boolean) => {
      
      if (isTimedOut) {
        console.log('Session Expired...');
        this.dialog.dialog.closeAll();
        setTimeout(() => {
          this.authservice.logout();
        }, 10);
        
      
        
      }
    });

    // this.bnIdle.startWatching(300).subscribe((res) => {
    //   if(res) {
    //       console.log("session expired");
    //   }
    // })

  }

  ngAfterViewInit() {
    this.preloader.hide();
  }
}
